import React, {useState, useEffect} from "react";
import {APP_URL, IMG_URL, amount_format,discount} from '../components/config/Common'

import { BiRupee } from "react-icons/bi";
import { motion as ms } from 'framer-motion';
import {Links} from '../routes/PathLink'
import CathLabRange from './CathLabRange2'

const CategoryHome = ({
   cat_id,
   title,
   description,
   link
}) => {

   const [user_type, setUser_type] = useState('')

    useEffect(() => {
          console.log('cat_id=====',cat_id);
         const user_type = localStorage.getItem('user_type');
         setUser_type(user_type);
      
    }, [cat_id])

   
   return (
     <>
       <CathLabRange
         title={title ? title : "Explore our <span class='font-semibold'>Cath Lab</span> Range"}
         description={"Distinguished by its comprehensive integration, a cath lab offers an extensive array of features designed to streamline and enhance surgical imaging procedures. From multiple table-side controls to a (...)"}
         link={link}
         cat_id={cat_id}
       />
     </>
   )
}

export default CategoryHome;